import { Component, OnInit, Input, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { AppService } from '../../services/app.service';

import { AuthenticationService } from '../../services/core/authentication.service';
import { ConfigService } from '../../services/core/config.service';

import { ModalRegisterComponent } from '../modal-register/modal-register.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConnectionService } from 'src/app/services/core/api-connection.service';


import * as $ from 'jquery';

@Component({
	selector: 'app-modal-login',
	templateUrl: './modal-login.component.html',
	styleUrls: ['./modal-login.component.scss']
})
export class ModalLoginComponent implements OnInit {
	@Input() public message;
	@Input() public isContentPreview = false;

	@Output() passEntry: EventEmitter<any> = new EventEmitter();
	public email = '';
	public password = '';
	error = false;
	warning = false;
	errorCode: any = false;
	errorMessage: any = false;
	emailValid = false;
	passwordValid = false;
	errorAccountDoesNotExist = false;
	errorEmailRequired = false;
	errorInvalidEmail = false;
	errorInvalidEmailTld = false;
	errorPasswordRequired = false;
	errorInvalidPassword = false;
	passwordResetSuccess = false;
	systemTitle = '';
	baseUrl = '';
	allowedTld: any;

	loginMethod = null;

	systemKey;
	cdnUrl;

	constructor(
		public activeModal: NgbActiveModal,
		private authenticateService: AuthenticationService,
		private ngxLoader: NgxUiLoaderService,
		private appService: AppService,
		private router: Router,
		private configService: ConfigService,
		private modalService: NgbModal,
		private ApiConnectionService: ApiConnectionService
	) {
		let self = this;

		this.systemTitle = configService.get('title');
		this.baseUrl = configService.get('front_url');
		this.allowedTld = configService.get('registration_allowed_extension');

		this.systemKey = configService.get('system_key');
		this.cdnUrl = configService.get('cdn_url');
	}

	ngOnInit() {
		const self = this;

		$("#password").on("change keyup paste", function (event) {
			self.checkPassword(event);
		})
	}

	filterEmailSpaces(event: any) {
		const self = this;

		self.email = (self.email).replace(/\s/g, '');
		setTimeout(function () {
			self.resetValidation();
			if (self.email.length < 3) {
				self.errorEmailRequired = true;
				self.loginMethod = null;
				return;
			} else if (self.validateEmail(self.email) === false) {
				self.errorInvalidEmail = true;
				self.loginMethod = null;
				return;
			} else if (self.validateTld(self.email) === false) {
				self.errorInvalidEmailTld = true;
				self.loginMethod = null;
				return;
			}

			//sent API call to check if e-mail is valid, and retrieve type
			self.authenticateService.getEmailType(self.email).then((res) => {
				if (res['STATUS'] == 'VALID') {
					self.loginMethod = res['TYPE'];
				} else if (res['ok'] == false) {
					self.errorAccountDoesNotExist = true;
					self.loginMethod = null;

					self.warning = true;
					self.errorCode = "USER_NOT_EXIST";
					self.errorMessage = "Hey! Dit e-mailadres kennen we nog niet, heb je het wel goed getypt?";
				}
			});

			if (self.password.length < 3) {
				self.errorPasswordRequired = true;
				return;
			}
		}, 50);
	}

	resetValidation() {
		this.error = false;
		this.warning = false;
		this.errorEmailRequired = false;
		this.errorInvalidEmail = false;
		this.errorInvalidEmailTld = false;
		this.errorPasswordRequired = false;
		this.emailValid = false;
		this.passwordValid = false;
		this.errorAccountDoesNotExist = false;
	}

	confirm() {
		this.resetValidation();

		if (this.email.length < 3) {
			this.errorEmailRequired = true;
			return;
		} else if (this.validateEmail(this.email) === false) {
			this.errorInvalidEmail = true;
			return;
		} else if (this.validateTld(this.email) === false) {
			this.errorInvalidEmailTld = true;
			return;
		}

		if (this.password.length < 3) {
			this.errorPasswordRequired = true;
			return;
		}

		let self = this;


		self.errorCode = false;
		self.errorMessage = false;

		self.ngxLoader.start();
		this.authenticateService.authenticate(this.email, this.password).then(function (response) {
			let routerUrl = self.router.url;
			if (routerUrl.includes('wachtwoord')) {
				window.location = self.configService.get('front_url');
			} else {
				window.location.hash = '';
				window.location.reload();
			}
		}).catch(function (error) {
			self.error = true;
			self.errorCode = error.error.code;
			self.errorMessage = error.error.message;
			self.ngxLoader.stop();
		});
	}

	close() {
		this.activeModal.close(false);
	}

	checkEmail(event) {
		this.errorEmailRequired = false;
		this.errorInvalidEmail = false;
		this.errorInvalidEmailTld = false;

		if (this.email.length < 3) {
			this.errorEmailRequired = true;
		} else if (this.validateEmail(this.email) === false) {
			this.errorInvalidEmail = true;
		} else if (this.validateTld(this.email) === false) {
			this.errorInvalidEmailTld = true;
		} else {
			this.emailValid = true;
		}
	}

	checkPassword(event) {
		if (this.password.length < 3) {
			this.passwordValid = false;
		} else {
			this.passwordValid = true;
		}
	}

	validateTld(email) {
		let emailPieces = email.split('.');
		let tld = emailPieces.pop();
		tld = tld.toLowerCase();

		let tldAllowed = false;
		for (let x = 0; x < this.allowedTld.length; x++) {
			if (this.allowedTld[x] == tld) {
				tldAllowed = true;
			}
		}

		return tldAllowed;
	}

	validateEmail(email) {
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	goToPasswordReset() {
		this.appService.showPasswordResetModal(this.email);
	}

	showRegister() {
		this.close();

		const self = this;
		setTimeout(function () {
			const registerModal = self.modalService.open(ModalRegisterComponent, { size: 'lg' });
			registerModal.componentInstance.registerHash = '';
		}, 200);
	}

	resetLogin() {
		this.loginMethod = null;
		this.password = "";
		this.resetValidation();
	}

	resetPassword() {
		this.resetValidation();

		if (this.email.length < 3) {
			this.errorEmailRequired = true;
			return;
		} else if (this.validateEmail(this.email) === false) {
			this.errorInvalidEmail = true;
			return;
		} else if (this.validateTld(this.email) === false) {
			this.errorInvalidEmailTld = true;
			return;
		}

		let self = this;

		this.ngxLoader.start();
		this.ApiConnectionService.save('users/passwordRecovery', { email: self.email }).then((response) => {
			self.ngxLoader.stop();
			self.passwordResetSuccess = true;
		}).catch(function (response) {
			self.ngxLoader.stop();
			self.error = true;
			for (let error in response['error']['errors']) {
				self.errorMessage = response['error']['errors'][error];
			}
		});
	}
}
